@if(currentRouteDay() && currentRouteDay()?.length > 0){
    @for(item of currentRouteDay(); track item.id) {
        @if(isFiturPolylines(item)){
            @if(item.fiturPolylinesPath?.bus?.length){
                <map-polyline [path]="item.fiturPolylinesPath?.bus" [options]="blueSolidPolylineOptions" />
                <map-polyline [path]="item.fiturPolylinesPath?.bus" [options]="borderPolylineOptions" />
            }
            @if(item.fiturPolylinesPath?.metro?.length){
                <map-polyline [path]="item.fiturPolylinesPath?.metro" [options]="redSolidPolylineOptions" />
                <map-polyline [path]="item.fiturPolylinesPath?.metro" [options]="borderPolylineOptions" />
            }
            @if(item.fiturPolylinesPath?.walking?.length){
                <map-polyline [path]="item.fiturPolylinesPath?.walking" [options]="dottedPolylineOptions" />
            }
        } @else {
            <map-polyline [path]="item.polylinesPath" [options]="blueSolidPolylineOptions" />
            <map-polyline [path]="item.polylinesPath" [options]="borderPolylineOptions" />
        }

    }
}